import { render, staticRenderFns } from "./education.vue?vue&type=template&id=8c91523a&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"
import style0 from "./education.vue?vue&type=style&index=0&id=8c91523a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c91523a",
  null
  
)

export default component.exports